/**
 * Converts a base64 data URL to a File object
 * @param base64Data - Base64 data URL (e.g., "data:image/png;base64,...")
 * @param filename - Desired filename for the File object
 * @returns File object ready for upload
 */
export const base64ToFile = (base64Data: string, filename: string): File => {
  // Remove data URL prefix (e.g., "data:image/png;base64,")
  const base64String = base64Data.split(',')[1];
  const byteCharacters = atob(base64String);
  const byteArrays: Uint8Array[] = [];

  for (let offset = 0; offset < byteCharacters.length; offset += 512) {
    const slice = byteCharacters.slice(offset, offset + 512);
    const byteNumbers = new Array(slice.length);
    for (let i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }
    byteArrays.push(new Uint8Array(byteNumbers));
  }

  const blob = new Blob(byteArrays, { type: 'image/png' });
  return new File([blob], filename, { type: 'image/png' });
};
